module.exports = __webpack_public_path__ + "img/stop.03f8587a.png";